<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Inicio</a></li>
                <li><a routerLink="/configuracion-calendario">Configuración del Calendario</a></li>
                <li>Calendario</li>
            </ul>
            <h2>Calendario</h2>
        </div>
    </div>
</div>

<div class="contenedor-principal">
    <div class="contenedor-grid">
        <div class="seccion-calendario">
            <div class="encabezado-controles">
                <div class="navegacion-mes">
                    <button mat-icon-button (click)="cambiarMes(-1)">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <div class="texto-mes">
                        <span class="selector-mes" (click)="mostrarSelectorMeses = true">
                            {{ currentDate | date:'MMMM' | titlecase }}
                        </span>
                        <span class="selector-anio" (click)="mostrarSelectorAnios = true">
                            {{ currentDate | date:'y' }}
                        </span>
                    </div>

                    <button mat-icon-button (click)="cambiarMes(1)">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
            </div>

            <div class="contenedor-calendario">
                <div class="grid-calendario">
                    <div class="encabezado-dias">
                        <div *ngFor="let dia of diasSemana" class="dia-semana">
                            {{ dia }}
                        </div>
                    </div>

                    <div class="contenedor-semanas">
                        <div *ngFor="let semana of semanas; trackBy: trackByWeek" class="semana">
                            <div *ngFor="let dia of semana; trackBy: trackByDay" 
                                class="celda-dia"
                                [class.dia-actual]="esHoy(dia)"
                                [class.mes-anterior-siguiente]="!perteneceAlMesActual(dia)"
                                [class.dia-seleccionado]="esDiaSeleccionado(dia)"
                                (click)="onDiaClick(dia)">
                                
                                <div class="numero-dia">{{ dia | date:'d' }}</div>
                                
                                <div class="indicadores-eventos">
                                    <div *ngFor="let evento of obtenerEventosDelDia(dia)" 
                                        class="punto-evento" 
                                        [style.background]="evento.color"
                                        [matTooltip]="evento.titulo">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="seccion-eventos">
            <div class="panel-evento">
                <div class="lista-eventos">
                    <div *ngIf="eventosDelDia.length === 0" class="sin-eventos">
                        <mat-icon class="icono-vacio">calendar_today</mat-icon>
                        <p>Seleccione un día en el calendario</p>
                    </div>

                    <div *ngFor="let evento of eventosDelDia" 
                        class="tarjeta-evento"
                        [style.border-left-color]="evento.color"
                        [class.expandida]="expandedEventos.get(evento._id!)"
                        (click)="toggleExpandida(evento._id!)">
                        
                        <div class="contenido-basico">
                            <div class="superior">
                                <h2 class="titulo-evento">{{ evento.titulo }}</h2>
                                <span class="hora-evento">
                                    {{ evento.fechaInicio | date:'dd/MM/yyyy HH:mm' }}
                                </span>
                            </div>
                        </div>

                        <div class="contenido-expandido" *ngIf="expandedEventos.get(evento._id!)">
                            <p class="descripcion">{{ evento.descripcion }}</p>
                            <div class="detalles-adicionales">
                                <div class="ubicacion">
                                    <mat-icon>location_on</mat-icon>
                                    <span>{{ evento.ubicacion }}</span>
                                </div>
                                <div class="duracion">
                                    <mat-icon>access_time</mat-icon>
                                    <span>
                                        {{ evento.fechaInicio | date:'HH:mm' }} - 
                                        {{ evento.fechaFin | date:'HH:mm' }}
                                    </span>
                                </div>
                            </div>

                            <div *ngIf="evento.links && evento.links.length > 0" class="seccion-links">
                                <h4>Links de interés:</h4>
                                <div class="lista-links">
                                    <div *ngFor="let link of evento.links" class="item-link">
                                        <mat-icon class="icono-link">link</mat-icon>
                                        <a *ngIf="link.label" [href]="link.link" target="_blank" (click)="$event.stopPropagation()">
                                            <span>{{ link.label }}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div class="acciones-evento" style="display: flex; gap: 8px; margin-top: 10px;">
                                <button mat-icon-button 
                                        class="boton-editar"
                                        (click)="$event.stopPropagation(); editarEvento(evento._id!)"
                                        matTooltip="Editar evento">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button 
                                        class="boton-eliminar"
                                        (click)="$event.stopPropagation(); eliminarEvento(evento._id!)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Spinner para eliminar -->
<app-spinner 
    [show]="isDeleting"
    [text]="'Eliminando evento'"
    [type]="'absolute'"
    [blurBackground]="true">
</app-spinner>

<!-- Spinner para cargar -->
<app-spinner 
    [show]="isLoading"
    [text]="'Cargando eventos'"
    [type]="'absolute'"
    [blurBackground]="true">
</app-spinner>